
import API_service from '../providers/API_service'
import creditCardType from 'credit-card-type'
import flex from '@cybersource/flex-sdk-web';
import { parseJwt } from 'xAppLib/helpers/jwt'

const DEBUG = false
const use_test = document.location.href.startsWith('https://localhost:9011/') 
				|| document.location.href.startsWith('http://localhost:9011/') 
				|| document.location.href.startsWith('http://inprep.test:9011/') 
				|| document.location.href.startsWith('https://scripts-dev.web.app') 
				|| document.location.href.startsWith('https://scripts-dev.firebaseapp.com')
				|| document.location.href.startsWith('https://t.iscr.com.au')
				|| document.location.href.startsWith('https://d.iscr.com.au')
				|| document.location.href.startsWith('https://pt.iscr.com.au')

export default class payment {

	static async tokeniseCard(card) {
		DEBUG && console.log('use_test=%o',use_test);
		DEBUG && console.log("tokeniseCard(%o, %o)",card, use_test)
		const data = await new Promise((resolve,reject)=>{
			API_service.call_api(
									'getCardPublicKey/2',
									null,
									result=>{
										if (result.error) {
											reject(result.error)
										} else {
											resolve(result)
										}
									}
							)
		})
		let jwk
		if (data.keyId) {
			const jwt = parseJwt(data.keyId)
			jwk = jwt.flx.jwk
		} else {
			jwk = data
		}
		
		let type;
		try {
			[{type}] = creditCardType(card.number)
		} catch (error) {
			throw Error('Card Type not found')
		} 
		
		DEBUG && console.log("card type=%p",type)
		switch(type) {
			case 'mastercard':
				type="002";
				break;
			case 'visa':
				type="001";
				break;
			case 'american-express':
				type="003";
				break;
			default:
				type='';
		}
		
		var options = {
                kid: jwk.kid,
                keystore: jwk,
				...jwk,
                cardInfo: {
                    cardNumber: card.number,
                    cardType: type,
                    cardExpirationMonth: card.expiry_month,
                    cardExpirationYear: card.expiry_year
                },
                encryptionType: 'rsaoaep256',
                production: !use_test // without specifying this tokens are created in test env
            };
		
		try {
			const token = await new Promise((resolve,reject)=>{
				flex.createToken(options,  (response) => {
						DEBUG && console.log("response=%o",response)
		                if (response.error !== undefined) {
		                    //alert('There has been an error!');
		                    DEBUG && console.log("error:",response);
							reject(response.error || "Unable to tokenise your card")
		                    return;
		                }

		                DEBUG && console.log('Token generated: ', JSON.stringify(response));
						resolve({...response, PAY_ENV:use_test?'TEST':'PROD'})

		            });
			})	   
			return token
		} catch (error) {
			console.log("error",error);
			const message = error.responseStatus?.details?.[0]?.message || error?.message || error || "Invalid card"
			DEBUG && console.log("message=%o",message);
			throw Error(message)
		} 
    
		
		
		

	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async authorisePayment(cardToken, amount, authoriseOnly = false) {
		
		return new Promise((resolve, reject)=>{
			API_service.call_api(
									'authorisePayment',
									{ cardToken, amount, authoriseOnly},
									result=>{
										if (result.error) {
											reject(result.error)
										} else {
											resolve(result)
										}
									}
							)
		})
	}

}
